export function Web() {
    return <>
        <h1>Work in progress!</h1>
    </>
}